module.exports = __webpack_public_path__ + "img/gartek-services-mechanical.10e8455f.jpeg";